import NewsVeiw from '../../../../shared/services/sub/news/NewsView';

export default function NewsViewSection() {
  return (
    <>
      <NewsVeiw />
    </>
  );
}
